import React from 'react';
import { GroupedSection } from '../../util/privacy-policies';
import { Breadcrumbs, PageHeader } from '@plataforma-xvia/design-system-es';
import { Container } from '@mui/material';
import { ContentWrap, PrivacyPoliciesWrap, Subtitle } from './style';
import buildAppPath from '../../utils/basePath';
import { ROUTES } from '../../routes';

export type PrivacyPoliciesProps = {
  privacyPolicies: GroupedSection[];
};

function getSizeTitle(sort: number): 'medium' | 'large' {
  if (sort < 1) return 'large';
  return 'medium';
}

export const PrivacyPolicies: React.FC<PrivacyPoliciesProps> = ({
  privacyPolicies,
}) => {
  return (
    <>
      <PageHeader
        title="Termos de Uso e Políticas de Privacidade"
        breadcrumb={
          <Breadcrumbs
            tone="inverted"
            showBackButton
            items={[
              { name: 'Início', path: buildAppPath('/') },
              {
                name: 'Termos de Uso e Políticas de Privacidade',
                path: buildAppPath(ROUTES.SERVICE_LIST_PAGE),
              },
            ]}
          />
        }
      />
      <PrivacyPoliciesWrap>
        <Container>
          {privacyPolicies.map((section, i) => (
            <div key={section.sectionTitle}>
              <h2>{section.sectionTitle}</h2>
              {section.items.map((item, idx) => (
                <ContentWrap key={idx}>
                  <div dangerouslySetInnerHTML={{ __html: item.content }} />
                </ContentWrap>
              ))}
            </div>
          ))}
        </Container>
      </PrivacyPoliciesWrap>
    </>
  );
};
